import BaseClass from "@/entities/BaseClass";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {h} from "vue";
import DialogRemoveItem from "@/elements/DialogRemoveItem";

export default class LinksClass extends BaseClass {
    urls = {
        count:  '/rest/databanks/numbers/count',
        list:   '/rest/databanks/numbers/list',
        create: '/rest/databanks/numbers/save',
        single: '/rest/databanks/numbers/single',
        update: '/rest/databanks/numbers/save',
        remove: '/rest/databanks/numbers/delete',

        removeAll: '/rest/databanks/numbers/delete-all',
        saveGroup: '/rest/databanks/numbers/save-group',
    }

    list(resolve = null, reject = null, customFilter = {}) {
        super.count(() => {
            super.list(resolve, reject, customFilter)
        }, null, customFilter);
    }

    saveGroup(entity_id, numbers, resolve = null, reject = null, customFilter = {}) {
        this.loading = true;

        this.makeRequest('saveGroup', {numbers: numbers, databank_id: entity_id}, Object.assign({}, this.filter, customFilter), (response) => {
            if (typeof resolve === 'function') {
                resolve(response);
            }
        }, reject);
    }

    remove(pks, databank_id, resolve, reject) {
        const { reveal } = createConfirmDialog(h(DialogRemoveItem, {
            header: 'Подтвердите удаление',
            description: 'После удаления данные не могут быть восстановлены. Вы уверены?',
            action: (modalResolve, modalReject) => {
                this.instance.loading = true;
                this.makeRequest('remove', {pks: pks, databank_id: databank_id}, Object.assign({}, this.filter), (data) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(data);
                    }
                }, (error) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(error);
                    }
                });
            }
        }));
        reveal();
    }

    removeAll(databank_id, resolve, reject, customFilter = {}) {
        const { reveal } = createConfirmDialog(h(DialogRemoveItem, {
            header: 'Подтвердите удаление',
            description: 'После удаления данные не могут быть восстановлены. Вы уверены?',
            action: (modalResolve, modalReject) => {
                this.instance.loading = true;
                this.makeRequest('removeAll', {databank_id: databank_id}, Object.assign({}, this.filter, customFilter), (data) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(data);
                    }
                }, (error) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(error);
                    }
                });
            }
        }));
        reveal();
    }

    create(databank_id, number, resolve, reject) {
        super.create({model: {databank_id: databank_id, number: number}}, (data) => {
            this.instance.emitter.emit('databank-numbers-list-changed');
            if (typeof resolve === 'function') {
                resolve(data);
            }
        }, reject);
    }
}
